import { AlarmSmokeIcon, ClipboardCheckIcon, FlameIcon, GaugeIcon, ShowerHeadIcon, SprayCanIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Fire Protection Fundamentals: Fire Science, Hazards & Protection Strategy',
    summary: 'A visual technical reference to how fire starts, grows and spreads, the classes of fire, extinguishing mechanisms and the complete protection strategy.',
    icon: FlameIcon,
  },
  {
    number: '02',
    title: 'Fire Detection & Alarm Systems: Detectors, Panels, Notification & Interfaces',
    summary: 'A visual technical reference to detectors, control panels, wiring and supervision, notification appliances and the interfaces a fire alarm system controls.',
    icon: AlarmSmokeIcon,
  },
  {
    number: '03',
    title: 'Fire Sprinkler Systems: Wet, Dry, Pre-Action & Deluge',
    summary: 'A visual technical reference to how sprinklers work, the four system types, riser components and the design concepts behind every installation.',
    icon: ShowerHeadIcon,
  },
  {
    number: '04',
    title: 'Fire Water Supply, Fire Pumps, Hydrants & Standpipes',
    summary: 'A visual technical reference to water supplies, flow tests, storage tanks, fire pumps and controllers, fire mains, hydrants and standpipes.',
    icon: GaugeIcon,
  },
  {
    number: '05',
    title: 'Special Hazard Suppression: Foam, Clean Agents, CO2, Water Mist & Dry Chemical',
    summary: 'A visual technical reference to foam systems, clean agent and CO2 total flooding, water mist, dry and wet chemical systems and how each is selected.',
    icon: SprayCanIcon,
  },
  {
    number: '06',
    title: 'Inspection, Testing, Maintenance & Industrial Fire Protection Operations',
    summary: 'A visual technical reference to inspection, testing and maintenance of every system, impairment management, hot work and fire protection in industrial plants.',
    icon: ClipboardCheckIcon,
  },
];
